module.exports = __webpack_public_path__ + "img/WP2023-banner.b57e7305.png";